module.exports = __webpack_public_path__ + "static/media/stop-circle.c2e135f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/stop-circle.svg
// module id = 812
// module chunks = 0